import type { PairEnrichmentSummaryDto } from '@rhcst/shared';
import { formatUsdPrice, relativeAge } from '../lib/format.js';

/**
 * Compact DexScreener market context for the pair feed row.
 *
 * Read-only display data (docs/DECISION_LOG.md ADR-053) — never a trading
 * input, never mixed into the risk verdict RiskBadge renders beside it.
 *
 * Unlike an unscored pair, which RiskBadge always renders explicitly because
 * risk is the product's central safety signal, a pair with no enrichment yet
 * renders nothing here rather than an "no market data" chip on every row —
 * most of the pair table will genuinely have no snapshot for a while after
 * enabling this integration, and a chip that says the same thing on hundreds
 * of rows is one the operator learns to ignore.
 */
export function EnrichmentBadge({
  enrichment,
}: {
  enrichment: PairEnrichmentSummaryDto | null;
}) {
  if (enrichment === null) return null;

  return (
    <span
      className="row-fact"
      title={`${enrichment.dex_id ?? 'DexScreener'} · updated ${relativeAge(enrichment.fetched_at)} ago`}
    >
      {formatUsdPrice(enrichment.price_usd)}
      {enrichment.stale && (
        <span
          className="chip"
          data-tone="muted"
          title="Last refresh is older than the configured interval"
        >
          Stale
        </span>
      )}
    </span>
  );
}
